import { Controller } from "@hotwired/stimulus"

// Select all / none in the copy modal.
//
// One control that flips rather than two buttons, since with everything
// already selected "Select all" is a no-op and vice versa.
export default class extends Controller {
  static targets = ["day", "toggle"]

  connect() {
    this.refresh()
  }

  toggleAll() {
    const selectAll = !this.allSelected
    this.dayTargets.forEach((day) => { day.checked = selectAll })
    this.refresh()
  }

  refresh() {
    if (!this.hasToggleTarget) return

    this.toggleTarget.textContent = this.allSelected ? "Select none" : "Select all"
  }

  get allSelected() {
    return this.dayTargets.length > 0 && this.dayTargets.every((day) => day.checked)
  }
}
